import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

const DeleteConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  deleteConfirmMessage,
  tableType,
}) => {
  const getMessage = () => {
    if (deleteConfirmMessage) return deleteConfirmMessage;
    const typeText =
      tableType === "orders"
        ? "siparişi"
        : tableType === "licenses"
        ? "lisansı"
        : "kaydı";
    return `Bu ${typeText} silmek istediğinizden emin misiniz?`;
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Silme Onayı</DialogTitle>
      <DialogContent>{getMessage()}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          İPTAL
        </Button>
        <Button onClick={onConfirm} color="error">
          SİL
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
